import { render, staticRenderFns } from "./ScoreAnalysis.vue?vue&type=template&id=74c56eaa&"
import script from "./ScoreAnalysis.vue?vue&type=script&lang=js&"
export * from "./ScoreAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ScoreAnalysis.vue?vue&type=style&index=0&id=74c56eaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports